export default __webpack_public_path__ + "static/media/oscer-pres-toe-pain.02ed8450.svg";